'use strict';

/**
 * Filter component view
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');
var CollectionView = require('base/Colido.CollectionView');
var FilterComponentView = require('modules/base/views/layout/filter-component');
var RecentMaterialsCollection = require('modules/collection/collections/recent-materials');
var Awesomplete = require('vendor/awesomplete');

var templateMaterialOption = require('modules/collection/templates/components/filter/material-option.hbs');
var template = require('modules/collection/templates/components/filter/material.hbs');

var MaterialListOptionView = ItemView.extend({
    template: templateMaterialOption,

    modelEvents: {
        'change': 'render',
    },
});

var MaterialListView = CollectionView.extend({
    childView: MaterialListOptionView,
});

var MaterialView = FilterComponentView.extend({
    template: template,

    ui: {
        'multipleOptions': '.component-filter-buttons',
        'speciesSearch': '#search-species',
    },

    events: {
        'change .component-filter-buttons input[type="checkbox"]': 'change',
        'input @ui.speciesSearch': 'onInputSpeciesField',
        'awesomplete-selectcomplete @ui.speciesSearch': 'onAwesompleteSelectComplete',
    },

    regions: {
        'recentListRegion': '.region-recent-list',
    },

    commonSpecies: [],

    recentSpecies: [
        {type: 1000689, displayName: 'Amethyst'},
        {type: 1000773, displayName: 'Fluorite'},
        {type: 3753, displayName: 'Pyromorphit'},
        {type: 1000656, displayName: 'Silver'},
    ],

    /**
     * Reference to awesomplete
     * @type {Awesomplete}
     */
    awesomplete: null,

    /**
     * Internal cache
     * @type {Object}
     */
    awesompleteCache: {},

    /**
     * Internal cache for assigning values to ids
     * @type {object}
     */
    materialValueToIdCache: {},

    recentCollection: null,

    viewData: {
        commonSpecies: function() {
            return this.commonSpecies;
        },
        recentSpecies: function() {
            return this.recentSpecies;
        },
    },

    listView: null,

    initialize: function(options) {
        FilterComponentView.prototype.initialize.apply(this, arguments);

        this.recentCollection = new RecentMaterialsCollection();

        // Listen to change events from recent collection
        this.listenTo(this.recentCollection, 'add', function(model) {
            model.collection.each(function(inlineModel, idx) {
                if (idx > 4) {
                    inlineModel.destroy();
                }
            });
        }.bind(this));

        this.listenTo(this.recentCollection, 'change', function(model) {
            this.change();
        }.bind(this));

        // Sort by time
        this.recentCollection.fetch({
            success: function(collection) {
                collection.sortByFields();
            },
        });

        this.commonSpecies = this.getCommonValues(5);
    },

    onRender: function() {
        FilterComponentView.prototype.onRender.apply(this, arguments);

        this.listView = new MaterialListView({
            collection: this.recentCollection,
        });

        this.recentListRegion.show(this.listView);
    },

    /**
     * Remove hidden input
     * @return {void}
     */
    onBeforeDestroy: function() {
        this.ui.speciesSearch.off();
    },

    getFilters: function() {
        var filters = [];

        var multipleOptions = this.ui.multipleOptions.find('input[type="checkbox"]').filter(':checked');

        multipleOptions.each(function(index, option){
            option = $(option);
            filters.push({value: option.val(), displayName: option.next('label').text().trim()});
        });

        return _.uniq(filters, 'value');
    },

    setFilters: function(filters) {
        filters = filters.split(',');

        this.ui.multipleOptions.find('input[type="checkbox"]').each(function(index, option){
            $(option).prop('checked', _.contains(filters, $(option).val()));
        });
    },

    resetFilters: function() {
        this.ui.multipleOptions.find('input[type="checkbox"]').each(function(index, option){
            $(option).prop('checked', false);
        });

        this.change();
    },

    change: function(event) {
        if (event) { //Uncheck all checkboxes with the same value
            var changedCheckbox = $(event.currentTarget);
            var changedValue = changedCheckbox.val();

            if (changedCheckbox.prop('checked') === false) {
                this.ui.multipleOptions.find('input[type="checkbox"]').each(function(index, option){
                    if ($(option).val() === changedValue) {
                        $(option).prop('checked', false);
                    }
                });
            }
        }

        FilterComponentView.prototype.change.apply(this, arguments);
    },

    onAttach: function() {
        // Init awesomplete
        this.awesomplete = new Awesomplete(this.ui.speciesSearch[0], {
            minChars: 1,
            maxItems: 6,
            list: [],
        });

        // Add small class
        this.$('.awesomplete').addClass('awesomplete--small');
    },

    /**
     * Is triggered, when the user inputs something into the species field
     * @param {object} event The input event
     */
    onInputSpeciesField: function(event) {
        // Get value
        var val = this.ui.speciesSearch.val();

        // Process response from api or cache
        if (this.awesompleteCache[val]) {
            this.processAutocompleteResponse(this.awesompleteCache[val]);
        } else {
            var request = $.getJSON(App.getApiUrl('/species/' + val));
            request.done(function(response) {
                this.awesompleteCache[val] = response;
                this.processAutocompleteResponse(response);
            }.bind(this));
        }
    },

    /**
     * Processes the response from API or cache
     * @param {object} response The response object, containing autocomplete items
     */
    processAutocompleteResponse: function(response) {
        if (this.awesomplete) {
            // Add name -> id relation
            var responseValues = _.values(response);
            _.each(responseValues, function(item) {
                if (!this.materialValueToIdCache[item.name]) {
                    this.materialValueToIdCache[item.name] = item.id;
                }
            }.bind(this));

            // Set new awesomplete list
            this.awesomplete.list = _.pluck(responseValues, 'name');
            this.awesomplete.evaluate();
        }
    },

    /**
     * Is triggered, when the user selects a value from autocomplete
     * @param {object} event The select complete event from awesomplete
     */
    onAwesompleteSelectComplete: function(event) {
        var materialName = this.ui.speciesSearch.val();

        if (this.materialValueToIdCache[materialName]) {
            var materialId = this.materialValueToIdCache[materialName];

            // Remove existing
            if (this.recentCollection.get(materialId)) {
                this.recentCollection.get(materialId).destroy();
            }

            // Add new
            this.recentCollection.create({
                id: materialId,
                name: materialName,
                time: new Date().getTime(),
            }, {
                success: function(model) {
                    model.set('selected', true);
                },
            });

            this.ui.speciesSearch.val('');
        }
    },

    getSortedValues: function() {
        if (!this.sortedValues) {
            var sortedValues = {};

            this.collection.each(function(model){
                var species = model.get('species');
                var speciesId;

                for(var i = 0; i < species.length; i++) {
                    speciesId = species[i].id;
                    if (sortedValues[speciesId]) {
                        sortedValues[speciesId].count++
                    } else {
                        sortedValues[speciesId] = {
                            count: 1,
                            type: speciesId,
                            displayName: species[i].name,
                        }
                    }
                }
            });

            this.sortedValues = _.sortBy(sortedValues, function(item) { return item.count * -1; });
        }

        return this.sortedValues;
    },

    getFilterValueDisplayName: function(value) {
        // var values = this.getSortedValues();
        // var species = _.findWhere(values, {type: parseInt(value,10)});
        // return  species ? species.displayName : value;
        return App.radio('collection').request('species:name', parseInt(value, 10));
    },
});

module.exports = MaterialView;